import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DataroomNode } from "@core/models/dataroom-node.model";
import { exitFullscreen, openElementFullscreen } from "@core/utils";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { DownloaderService } from "@core/downloader/downloader.service";
import { TypedFormGroup } from '@feature/forms/form-model';

export interface PreviewDialogData {
  node: DataroomNode;
}


@Component({
    selector: 'wai-preview-dialog',
    templateUrl: './preview-dialog.component.html',
    styleUrls: ['./preview-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PreviewDialogComponent implements OnDestroy {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  isLoading = false
  isFullscreen = false
  fileContent: SafeUrl = null;
  private url: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: PreviewDialogData,
    private dialogRef: MatDialogRef<PreviewDialogComponent>,
    private sanitizer: DomSanitizer,
    private elRef: ElementRef,
    private downloader: DownloaderService,
    private cdr: ChangeDetectorRef,
  ) {
    this.download();
  }

  ngOnDestroy(): void {
    if (this.url) {
      URL.revokeObjectURL(this.url);
    }
  }

  download(): void {
    this.isLoading = true;
    this.downloader.download(this.dialogData.node.file.url)
      .subscribe((blob) => {
        this.url = URL.createObjectURL(blob);
        this.fileContent = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        this.isLoading = false;
        this.cdr.detectChanges();
      });
  }

  toggleFullscreen(): void {
    const element = (this.elRef.nativeElement as HTMLElement)?.closest('mat-dialog-container');

    if (!element) {
      return;
    }

    if (this.isFullscreen) {
      exitFullscreen();
      this.isFullscreen = false;
    } else {
      this.isFullscreen = openElementFullscreen(element);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
